// 汇率常量（EUR 为基准货币）
export const EUR_TO_GBP_RATE = 0.86; // 1 EUR = 0.86 GBP
export const GBP_TO_EUR_RATE = 1 / EUR_TO_GBP_RATE; // 1 GBP ≈ 1.1628 EUR

// 将欧元金额转换为英镑
export const convertEurToGbp = (eurAmount) => {
  if (eurAmount == null || isNaN(eurAmount)) return 0;
  return Number(eurAmount) * EUR_TO_GBP_RATE;
};

// 判断当前语言是否需要显示英镑（未就绪时与 i18n.init 默认 lng「en」一致，避免首屏 €/£ 错位）
export const isGbpLanguage = (language) => {
  const lang = (language || "en").toLowerCase();
  return lang === "uk" || lang.startsWith("en");
};

/** 文案中的 € 金额（含 HTML），如 €250、€4.95、€4,95 */
const EUR_AMOUNT_IN_TEXT = /€\s*(\d+(?:[.,]\d{1,2})?)/g;

function parseEurAmountToken(numStr) {
  const s = String(numStr).trim();
  if (/^\d+$/.test(s)) return parseFloat(s, 10);
  if (/^\d+,\d{1,2}$/.test(s)) return parseFloat(s.replace(",", "."), 10);
  if (/^\d+\.\d{1,2}$/.test(s)) return parseFloat(s, 10);
  const n = parseFloat(s.replace(/\./g, "").replace(",", "."));
  return Number.isFinite(n) ? n : NaN;
}

function formatGbpFromEurAmount(eur) {
  const gbp = convertEurToGbp(eur);
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(gbp)
    .replace(/\u00A0/g, " ");
}

/**
 * 将字符串中的 € 金额替换为按汇率换算后的 £ 展示（仅 uk/en 语言）。
 * 用于 i18n 里写死的欧元文案（帮助中心、页脚等）。
 */
export function localizeEuroAmountsInString(str, language) {
  if (str == null || typeof str !== "string") return str;
  if (!isGbpLanguage(language)) return str;
  return str.replace(EUR_AMOUNT_IN_TEXT, (_, amount) => {
    const eur = parseEurAmountToken(amount);
    if (!Number.isFinite(eur)) return `€${amount}`;
    return formatGbpFromEurAmount(eur);
  });
}
